import { AssetWithUsersV26 } from 'src/app/models-v26/asset-with-users-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { SwapContractInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/swap-contract-wizard/init-step/swap-contract-init-step';

export interface State {
  initStep: SwapContractInitStepV26;
  assetTobeCancelledStep: AssetWithUsersV26;
  validationResponse: ActionResponse;
  validationErrorMessage: string;
  newOrderResponse: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  assetTobeCancelledStep: null,
  validationResponse: null,
  validationErrorMessage: null,
  newOrderResponse: null,
  errorMessage: null,
};
